import BaseLocationListDrawer from './BaseLocationListDrawer';

export default BaseLocationListDrawer;
